import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import HighlightsPanelLayout from './highlights-panel-layout';

class HighlightsPanelComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        if (!this.options.endpointUrl) {
            throw new Error('Invalid endpoint URL');
        }

        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <HighlightsPanelLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default HighlightsPanelComponent;
